module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_40_50.4dd39c6e.png";